import script from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Sidebar.vue?vue&type=script&setup=true&lang=ts"

import "./Sidebar.vue?vue&type=style&index=0&id=3def6358&lang=css"

const __exports__ = script;

export default __exports__